import { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { RouteLoading } from "@/components/Loading/RouteLoading";
import { supabase } from "@/integrations/supabase/client";

interface ProtectedRouteProps {
  children: ReactNode;
  requireOnboarding?: boolean;
}

export const ProtectedRoute = ({ children, requireOnboarding = true }: ProtectedRouteProps) => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(requireOnboarding);

  useEffect(() => {
    if (isLoading) return;

    if (!user) {
      navigate('/auth', { replace: true });
      return;
    }

    if (requireOnboarding) {
      const localFlag = localStorage.getItem('onboardingComplete');
      if (localFlag) {
        setChecking(false);
        return;
      }

      // Fallback: check if budget_settings exists in DB (user already onboarded on another device)
      supabase
        .from('budget_settings')
        .select('user_id')
        .eq('user_id', user.id)
        .maybeSingle()
        .then(({ data }) => {
          if (data) {
            // User has DB settings — skip onboarding, set localStorage flag
            localStorage.setItem('onboardingComplete', 'true');
            setChecking(false);
          } else {
            navigate('/onboarding', { replace: true });
          }
        });
    } else {
      setChecking(false);
    }
  }, [user, isLoading, navigate, requireOnboarding]);

  if (isLoading || !user || checking) {
    return <RouteLoading />;
  }

  return <>{children}</>;
};
